module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division I16.b5153b86.png";